import React from 'react';

const EmptyTableBody = ({
  emptyMessage = 'Er zijn momenteel nog geen items toegevoegd.',
  className = '',
  headerLength
}) => (
  <tbody className={`spo-o-table__body--empty ${className}`}>
    <tr>
      <td colSpan={headerLength}>{emptyMessage}</td>
    </tr>
  </tbody>
);

export default EmptyTableBody;
